import _ from 'lodash'

import SheetButton from 'src/components/widgets/buttons/SheetButton/SheetButton'

const PromoCodeButton = ({
  isDisabled,
  onClick,
  testid,
}: {
  isDisabled: boolean
  onClick: () => void
  testid: string
}) => (
  <SheetButton
    title="Add Promo Code"
    data-testid={testid}
    subtitle={
      isDisabled
        ? "To add your Promo Code, first add a seller's direct product URL."
        : ''
    }
    isDisabled={isDisabled}
    mt={6}
    width="full"
    onClick={onClick}
  />
)

export default PromoCodeButton
